import React, { useState } from 'react';
import { Select } from 'antd';
import { ChevronLeft, RotateCcw } from 'react-feather';
import styles from './stylesCreateNewSGP.module.css';

function CreateNewSGP({ onBack }) {
    const [formData, setFormData] = useState({
        matchDate: '2025/10/05',
        match: 'Chicago Bulls vs. Sacramento Kings (8:00 PM)',
        numberOfLegs: 3,
        provider: 'Sportradar',
        legs: [
            {
                market: 'Moneyline (incl. overtime)',
                value: 'Bulls'
            },
            {
                market: 'Spread',
                value: 'Bulls -7.0'
            },
            {
                market: '',
                value: ''
            }
        ]
    });

    const handleLegChange = (legIndex, field, value) => {
        const updatedLegs = [...formData.legs];
        updatedLegs[legIndex] = {
            ...updatedLegs[legIndex],
            [field]: value
        };
        setFormData({
            ...formData,
            legs: updatedLegs
        });
    };

    const clearLeg = (legIndex) => {
        const updatedLegs = [...formData.legs];
        updatedLegs[legIndex] = {
            market: '',
            value: ''
        };
        setFormData({
            ...formData,
            legs: updatedLegs
        });
    };

    const marketOptions = [
        'Moneyline (incl. overtime)',
        'Spread',
        'Total Points',
        'Player Props',
        'Team Props'
    ];

    const valueOptions = {
        'Moneyline (incl. overtime)': ['Bulls', 'Kings'],
        'Spread': ['Bulls -7.0', 'Kings +7.0'],
        'Total Points': ['Over 220.5', 'Under 220.5'],
        'Player Props': ['LeBron James Over 25.5 Points', 'LeBron James Under 25.5 Points'],
        'Team Props': ['Bulls First Quarter Winner', 'Kings First Quarter Winner']
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <button className={styles.backButton} onClick={onBack}>
                    <ChevronLeft size={20} />
                </button>
                <h1>Create New SGP</h1>
            </div>

            <div className={styles.content}>
                {/* Left Section - Form */}
                <div className={styles.formSection}>
                    {/* Match Details */}
                    <div className={styles.section}>
                        <h3>Match Details</h3>
                        <div className={styles.formRow}>
                            <div className={styles.formField}>
                                <span>Match Date</span>
                                <div className={styles.dateInput}>
                                    <input
                                        type="text"
                                        value={formData.matchDate}
                                        readOnly
                                        className={styles.dateField}
                                    />
                                    <span className={styles.calendarIcon}>📅</span>
                                </div>
                            </div>
                            <div className={styles.formField}>
                                <span>Match</span>
                                <Select
                                    value={formData.match}
                                    className={styles.selectField}
                                    options={[
                                        { value: "Chicago Bulls vs. Sacramento Kings (8:00 PM)", label: "Chicago Bulls vs. Sacramento Kings (8:00 PM)" },
                                        { value: "Lakers vs. Warriors (9:00 PM)", label: "Lakers vs. Warriors (9:00 PM)" }
                                    ]}
                                />
                            </div>
                        </div>
                    </div>

                    <div className={styles.underline}></div>

                    {/* Conditions */}
                    <div className={styles.section}>
                        <h3>Conditions</h3>
                        <div className={styles.formRow}>
                            <div className={styles.formField}>
                                <span>Number of Legs</span>
                                <Select
                                    value={formData.numberOfLegs}
                                    className={styles.selectField}
                                    options={[
                                        { value: 2, label: "2" },
                                        { value: 3, label: "3" },
                                        { value: 4, label: "4" },
                                        { value: 5, label: "5" }
                                    ]}
                                />
                            </div>
                            <div className={styles.formField}>
                                <span>Provider</span>
                                <Select
                                    value={formData.provider}
                                    className={styles.selectField}
                                    options={[
                                        { value: "Sportradar", label: "Sportradar" },
                                        { value: "ESPN", label: "ESPN" },
                                        { value: "The Athletic", label: "The Athletic" }
                                    ]}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Leg Details */}
                    <div className={styles.section}>
                        <h3>Leg Details</h3>
                        {formData.legs.map((leg, index) => (
                            <div key={index} className={styles.legSection}>
                                <div className={styles.legHeader}>
                                    <h4>#{index + 1} Leg</h4>
                                    <button
                                        className={styles.clearButton}
                                        onClick={() => clearLeg(index)}
                                    >
                                        Clear
                                        <span className={styles.clearButtonIcon}>
                                            <RotateCcw size={16} />
                                        </span>
                                    </button>
                                </div>
                                <div className={styles.legRow}>
                                    <div className={styles.formField}>
                                        <span>Market</span>
                                        <Select
                                            value={leg.market}
                                            placeholder="Not selected"
                                            onChange={(value) => handleLegChange(index, 'market', value)}
                                            className={styles.selectField}
                                            options={marketOptions.map(option => ({ value: option, label: option }))}
                                        />
                                    </div>
                                    <div className={styles.formField}>
                                        <span>Value</span>
                                        <Select
                                            placeholder="Not selected"
                                            value={leg.value}
                                            onChange={(value) => handleLegChange(index, 'value', value)}
                                            className={styles.selectField}
                                            options={leg.market ? valueOptions[leg.market]?.map(option => ({ value: option, label: option })) : []}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className={styles.buttonContainer}>
                        <button
                            type="primary"
                            className={styles.createButton}
                            size="large"
                        >
                            Create
                        </button>
                    </div>
                </div>  

                {/* Right Section - Summary */}
                <div className={styles.summarySection}>
                    <h3>Summary</h3>
                    <div className={styles.underline}></div>
                    <div className={styles.summaryContent}>
                        <div className={styles.summaryItem}>
                            <span className={styles.summaryLabel}>Date</span>
                            <span className={styles.summaryValue}>Oct 05, 2025 8:00 PM</span>
                        </div>
                        <div className={styles.summaryItem}>
                            <span className={styles.summaryLabel}>Match</span>
                            <span className={styles.summaryValue}>Chicago Bulls vs. Sacramento Kings</span>
                        </div>
                        <div className={styles.summaryItem}>
                            <span className={styles.summaryLabel}>Provider</span>
                            <span className={styles.summaryValue}>Sportradar</span>
                        </div>
                        <div className={styles.underline}></div>
                        <div className={styles.summaryTotal}>
                            <div className={styles.summaryItem}>
                                <span className={styles.summaryLabel}>Total Odds</span>
                                <span className={styles.summaryValue}style={{ fontSize: '20px' }}>+210</span>
                            </div>
                            <div className={styles.summaryItem}>
                                <span className={styles.summaryLabel}>Number of Legs</span>
                                <span className={styles.summaryValue} style={{ fontSize: '20px' }}>3</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CreateNewSGP;

